import {FETCH_CAT_INFO, FETCH_CATS} from '../actions';

const initialState = {
	children: [{
		term_id: 0,
		name: "Loading",
	}],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CAT_INFO:
        	return action.payload;
        case FETCH_CATS:
            return action.payload;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/cat-reducer.js